import React from 'react';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useUser } from 'apps/sigma2-ui/src/state/user';

export const useSelectedOrganizationId = () => {
  const [searchParams] = useSearchParams();
  const { myUser } = useUser();

  return useMemo(() => {
    const param = searchParams.get('organizationId');
    return param ?? myUser?.organization?.id ?? null;
  }, [myUser, searchParams]);
};
